import ScrollToTop from "@/components/base/ScrollToTop";
import Layout from "@/components/feature/Layout";
import HomeHero from "./components/HomeHero";
import CategorySection from "./components/CategorySection";
import FeaturedArticles from "./components/FeaturedArticles";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import HomeSEO from "./components/HomeSEO";

export default function Home() {
  return (
    <>
      <HomeSEO />
      <ScrollToTop />
      <Layout heroContent={<HomeHero />} showFullHero>
        <CategorySection />
        <FeaturedArticles />
        <TestimonialSection />
        <FAQSection />
        <CTASection />
      </Layout>
    </>
  );
}